// import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer } from 'recharts';

function RevenueGenerated({ revenueGeneratedData }) {
    return (
        <div className="border rounded-lg border-[#EAEAEA] w-full min-h-[50vh] p-5 flex flex-col gap-4">
            <div className="chart-data">
                <h1 className="font-semibold text-base">Revenue Generated</h1>

                <div className="labels"></div>
            </div>

            <div className="m-auto">
                <h1 className='font-normal italic text-base text-[#666666]'>Available soon</h1>
            </div>

            {/* <ResponsiveContainer width="100%" height="100%">
                <LineChart
                    data={revenueGeneratedData} 
                    margin={{
                        top: 10,
                        right: 20,
                        bottom: 10,
                        left: 10,
                    }}
                >
                    <XAxis 
                        dataKey="name" 
                        tickLine={false} 
                        tickMargin={15} 
                        type='category' 
                    />

                    <YAxis 
                        tickCount={6} 
                        tickLine={false} 
                        tickMargin={15} 
                        type="number" 
                        domain={[0, 50000]} 
                        width={75}
                    />

                    <Tooltip />
                    
                    <Line dot={false} type="monotone" dataKey="uv" stroke="#8884d8" />
                </LineChart>
            </ResponsiveContainer> */}
        </div>
    )
}

export default RevenueGenerated;
